import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
const date = new Date();
export const managerdateFormat = moment(date).format("YYYY-MM-DD")

const initialState = {
  has_note: null,
  page: 1,
  unreachable_submitter: null,
  hasMessage: null,
  month: null,
  year: null,
  submit_place: null,
  user_id: null,
  // manager_id: null,
  quality_team_id: null,
  people_appearing: null,
  person_who_filmed: null,
  submit_other_website: null,
  aggrement_with_another_company: null,
  from: "2021-01-01",
  to: managerdateFormat,
};

const managerConfirmedApprovedApproved = createSlice({
  name: "managerConfirmedApprovedApproved",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setHasNote: (state, action) => {
      state.has_note = action.payload;
    },
    setUnreachableSubmitter: (state, action) => {
      state.unreachable_submitter = action.payload;
    },
    setHasMessage: (state, action) => {
      state.hasMessage = action.payload;
    },
    setMonth: (state, action) => {
      state.month = action.payload;
    },
    setYear: (state, action) => {
      state.year = action.payload;
    },
    setSubmitPlace: (state, action) => {
      state.submit_place = action.payload;
    },
    setUserId: (state, action) => {
      state.user_id = action.payload;
    },
    setManagerId: (state, action) => {
      state.manager_id = action.payload;
    },
    setQualityTeamId: (state, action) => {
      state.quality_team_id = action.payload;
    },
    setPeopleAppearing: (state, action) => {
      state.people_appearing = action.payload;
    },
    setPersonWhoFilmed: (state, action) => {
      state.person_who_filmed = action.payload;
    },
    setSubmitOtherWebsite: (state, action) => {
      state.submit_other_website = action.payload;
    },
    setAgreementWithAnotherCompany: (state, action) => {
      state.aggrement_with_another_company = action.payload;
    },
    setFrom: (state, action) => {
      state.from = action.payload;
    },
    setTo: (state, action) => {
      state.to = action.payload;
    },
    setDuplicates: (state, action) => {
      state.duplicates = action.payload;
    },
  },
});

export const {
  setPage,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setMonth,
  setYear,
  setSubmitPlace,
  setUserId,
  setManagerId,
  setQualityTeamId,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
  setDuplicates,
} = managerConfirmedApprovedApproved.actions;

export default managerConfirmedApprovedApproved.reducer;
